module.exports = __webpack_public_path__ + "img/Image_logo_13.970f2b91.jpg";